import { Component } from '@angular/core';

@Component({
  selector: 'app-transportation',
  standalone: true,
  imports: [],
  templateUrl: './transportation.component.html',
  styleUrl: './transportation.component.scss'
})
export class TransportationComponent {

}
